module.exports = __webpack_public_path__ + "static/media/nima-with-mum.9880564f.gif";